import React from "react";
import {
  ToolbarSection,
  ToolbarItem,
  ToolbarRadioButtonGroup,
  ToolbarRow,
} from "@editor";
import { useNode } from "@craftjs/core";
import {
  AlignHorizontalLeft,
  AlignHorizontalCenter,
  AlignHorizontalRight,
  AlignVerticalTop,
  AlignVerticalBottom,
  AlignVerticalCenter,
} from "@editor/icons";

export const BoxSettings = () => {
  const {
    actions: { setProp },
    getPropValue,
  } = useNode((node) => {
    return {
      getPropValue: (propKey: string) => node.data.props[propKey],
    };
  });

  return (
    <React.Fragment>
      <ToolbarSection title="Stack options" defaultOpen={true}>
        <ToolbarItem
          label="Layout"
          propKey="flexDirection"
          type="select"
          options={[
            { label: "Vertical", value: "column" },
            { label: "Horizontal", value: "row" },
          ]}
        />
        <ToolbarItem label="Gap" propKey="gap" type="text" />
        {/* <ToolbarItem
          label="Gap"
          propKey="gap"
          type="select"
          options={[
            { label: "Default", value: "" },
            { label: "None", value: "0" },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
          ]}
        /> */}
        <ToolbarRadioButtonGroup
          name="flexbox-alignment-vertical"
          inline={true}
          defaultValue={getPropValue("alignItems")}
          options={[
            {
              label: "Top",
              value: "flex-start",
              icon: <AlignVerticalTop />,
            },
            {
              label: "Center",
              value: "center",
              icon: <AlignVerticalCenter />,
            },
            {
              label: "Bottom",
              value: "flex-end",
              icon: <AlignVerticalBottom />,
            },
          ]}
          onSelect={(value) => {
            setProp((props: any) => {
              props["alignItems"] = value;
            }, 500);
          }}
        />
        <ToolbarRadioButtonGroup
          name="flexbox-alignment-horizontal"
          inline={true}
          defaultValue={getPropValue("justifyContent")}
          options={[
            {
              label: "Left",
              value: "flex-start",
              icon: <AlignHorizontalLeft />,
            },
            {
              label: "Center",
              value: "center",
              icon: <AlignHorizontalCenter />,
            },
            {
              label: "Right",
              value: "flex-end",
              icon: <AlignHorizontalRight />,
            },
          ]}
          onSelect={(value) => {
            setProp((props: any) => {
              props["justifyContent"] = value;
            }, 500);
          }}
        />
      </ToolbarSection>
    </React.Fragment>
  );
};
